module.exports = __webpack_public_path__ + "img/edit.48200a24.svg";